<template>
    <svg 
        xmlns="http://www.w3.org/2000/svg"
        :height="height"
        :width="width"
        viewBox="0 0 50 100"
    >
        <slot />
    </svg>
</template>

<script>
    export default {
        props: ['width', 'height']
    }
</script>